// extracted by mini-css-extract-plugin
module.exports = {"Widget":"WidgetButton_Widget__iAMlT","WidgetButton":"WidgetButton_WidgetButton__3NStu"};